
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import LoanModal from './LoanModal';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';
import { Card } from 'react-bootstrap';
import { FaFilter } from "react-icons/fa";

const LoanList = ({ }) => {
    const [loans, setLoan] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedLoanId, setSelectedLoanId] = useState(null);
    const [selectedLoanData, setSelectedLoanData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [countries, setCountries] = useState([]);
    const [errors, setErrors] = useState({});
    const [industries, setIndustries] = useState([]);
    const WithCreatePermission = withPermission(({ children }) => children, ['loan-create']);
    const WithEditPermission = withPermission(({ children }) => children, ['loan-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['loan-delete']);
    const didFetchRef = useRef(false);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [showSlideModal, setShowSlideModal] = useState(false);
    const didInitialFetch = useRef(false);
    const [sectorFilter, setSectorFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null);
    useEffect(() => {

        // fetchLoan(); // fetch initial page
        // fetchIndustries();
    }, []);
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchLoan(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]); // Add typeFilter and sectorFilter to the dependency array
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };
    const fetchLoan = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            let params = { page };

            const response = await axios.get(`${backendUrl}/api/loans`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params,
            });

            // pagination object
            const pagination = response.data?.data;

            // loans array
            setLoan(pagination?.data || []);
            setCurrentPage(pagination?.current_page || 1);
            setPageCount(pagination?.last_page || 1);

        } catch (error) {
            console.error("Error fetching loans:", error);
        }
    };

    const fetchEmployee = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            let allIndustries = [];
            let currentPage = 1;
            let lastPage = 1;


            const response = await axios.get(`${backendUrl}/api/employee`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            allIndustries = [...allIndustries, ...response.data.data]


            setIndustries(allIndustries);
        } catch (error) {
            console.error('Error fetching employee:', error);
        }
    };


    const addLoan = async (newLoan) => {
        try {
            const formData = new FormData();
            // Append regular fields
            Object.keys(newLoan).forEach((key) => {
                formData.append(key, newLoan[key]);
            });


            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for adding
            const response = await axios.post(`${backendUrl}/api/loans`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            const createdLoan = response.data.data;

            if (createdLoan) {
                setLoan((prevLoan) => [...prevLoan, createdLoan]);
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error(`Error adding Loan`, error);
            }
        }
    };


    const editLoan = async (contactId, updatedData) => {
        try {

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for editing
            const response = await axios.put(`${backendUrl}/api/loans/${contactId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            const updatedLoan = response.data.data;

            if (updatedLoan) {
                setLoan((prevLoan) =>
                    prevLoan.map((contact) => (contact.id === updatedLoan.id ? updatedLoan : contact))
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else
                console.error(`Error updating`, error);
        }
    };

    const deleteLoan = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');

                    const token = userInfo?.token;

                    // Corrected API endpoint with dynamic contact_type for deleting
                    await axios.delete(`${backendUrl}/api/loans/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setLoan(loans.filter((contact) => contact.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The Loan has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting Loan:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete Loan. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (contactId = null) => {
        if (contactId) {
            const contactToEdit = loans.find((contact) => contact.id === contactId);
            if (contactToEdit) {
                setSelectedLoanData(contactToEdit);
            }
        } else {
            setSelectedLoanData(null);
        }
        setSelectedLoanId(contactId);
        // setShowModal(true);
        setShowSlideModal(true);

    };
    const handleShowSlideModal = () => {
        setSelectedLoanData(null);
        setSelectedLoanId(null);
        setShowSlideModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
        setShowSlideModal(false);

        setSelectedLoanId(null);
        setSelectedLoanData(null);
        setErrors({});
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchLoan(selectedPage);
    };
    const getIndustryNameById = (industryId) => {
        const industry = industries.find(industry => industry.id == industryId);
        return industry ? industry.name : '';
    };
    const formatOrgType = (type) => {
        if (!type) return ''; // Return empty string if type is null or undefined
        return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase().replace(/_/g, ' ');
    };

    const [viewType, setViewType] = useState('list');
    const handleFilterChange = (filterType, value) => {
        if (filterType === 'sector') setSectorFilter(value);
        if (filterType === 'type') setTypeFilter(value);

        setFilterDropdown(null); // Close dropdown after selection
    };

const getStatusBadge = (status) => {
        switch (status) {
            case 'approved':
                return <span className="badge bg-success">Approved</span>;
            case 'rejected':
                return <span className="badge bg-danger">Rejected</span>;
            default:
                return <span className="badge bg-warning">Pending</span>;
        }
    };


    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">
                                    loans
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    {/* <div className="d-flex justify-content-end mb-3"> */}
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                        <div className="d-flex align-items-center">

                                            <WithCreatePermission>
                                                <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                    onClick={handleShowSlideModal}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Add Loan"
                                                >
                                                    <i className="mdi mdi-plus"></i>
                                                </button>
                                            </WithCreatePermission>

                                        </div></div>

                                    <table className="table align-middle table-nowrap table-hover table-check table-list">
                                        <thead className="table-sales-gradient">
                                            <tr>
                                                <th style={{ width: '20px' }} className="align-middle">
                                                    <div className="form-check font-size-16">
                                                        <input className="form-check-input" type="checkbox" id="checkAll" />
                                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                                    </div>
                                                </th>
                                                <th className="align-middle">#</th>
                                                <th className="align-middle">Date</th>
                                                <th className="align-middle">Title</th>
                                                <th className="align-middle">Employee</th>
                                                <th className="align-middle">Amount</th>
                                                <th className="align-middle">Monthly Installment</th>
                                                <th className="align-middle">Due</th>
                                                <th className="align-middle">Status</th>

                                                <th className="align-middle">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loans.length > 0 ? (
                                                loans.map((loan, index) => (
                                                    <tr key={loan.id}>
                                                        <td>
                                                            <div className="form-check font-size-16">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`loanCheck${index}`}
                                                                />
                                                                <label className="form-check-label" htmlFor={`loanCheck${index}`}></label>
                                                            </div>
                                                        </td>
                                                        <td>{index + 1}</td>
                                                        <td>{loan.start_date}</td>
                                                        <td>{loan.title}</td>
                                                        <td>{loan.employee?.first_name} {loan.employee?.last_name}</td>
                                                        <td>{loan.loan_amount}</td>
                                                        <td>{loan.installment_amount}</td>
                                                        <td>{loan.balance_amount}</td> {/* ✅ Balance Amount (Due) */}
                                                        <td>{getStatusBadge(loan.status)}</td>
                                                        <td>
                                                            <div className="dropdown font-size-13">
                                                                <i
                                                                    className="mdi mdi-dots-horizontal font-size-17"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    style={{ cursor: 'pointer' }}
                                                                ></i>
                                                                <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                    <li>
                                                                        <Link to={`/Loan/details/${loan.id}`} className="dropdown-item">
                                                                            View Details
                                                                        </Link>
                                                                    </li>
                                                                    <li><WithEditPermission>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => handleShowModal(loan.id)}
                                                                        >
                                                                            Edit
                                                                        </button></WithEditPermission>
                                                                    </li>
                                                                    <li><WithDeletePermission>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => deleteLoan(loan.id)}
                                                                        >
                                                                            Delete
                                                                        </button></WithDeletePermission>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="10" className="text-center">No loans found.</td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageClick}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>



            <LoanModal
                showModal={showSlideModal}
                handleClose={handleCloseModal}
                LoanId={selectedLoanId}
                LoanData={selectedLoanData}
                addLoan={addLoan}
                editLoan={editLoan}
                loans={loans}
                errors={errors}
                setErrors={setErrors}
                employees={industries}
                fetchEmployees={fetchEmployee}
            />
        </div>
    );
};

export default LoanList;




